module.exports = __webpack_public_path__ + "d409f0efb03b7e555adf12a362ca879e.jpg";